import {Box, HStack, Icon} from 'platform/foundation';
import {css, useTheme} from 'styled-components';

interface ImagePreviewZoomActionsProps {
  onZoomOut: VoidFunction;
  onZoomIn: VoidFunction;
}

export function ImagePreviewZoomActions(props: ImagePreviewZoomActionsProps) {
  const theme = useTheme();
  return (
    <div
      css={css`
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: ${theme.zIndices.LIGHTBOX_DETAIL_ACTIONS};
      `}
    >
      <div
        css={css`
          border-radius: ${({theme}) => theme.radii.small};
          color: ${({theme}) => theme.colors.general.white};
          background-color: ${({theme}) => theme.colors.palettes.black[900][70]};
          opacity: ACTIONS_OPACITY;
        `}
      >
        <HStack>
          <Box padding={2} opacity={ACTIONS_OPACITY}>
            <Icon value="content/remove" onClick={props.onZoomOut} />
          </Box>
          <Box padding={2} opacity={ACTIONS_OPACITY}>
            <Icon value="content/add" onClick={props.onZoomIn} />
          </Box>
        </HStack>
      </div>
    </div>
  );
}

const ACTIONS_OPACITY = 0.6;
